module.exports = __webpack_public_path__ + "media/images/pic/groups/small/early-school-34062b965059f49ec138d29619b58e68.jpeg";